import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";

import { PageLayout } from "./components/PageLayout";
import { Reports } from "./pages/reports/Reports";
import { Schedule } from "./pages/schedule/Schedule";
import { ScheduleCalendarPage } from "./pages/schedule/ScheduleCalendarPage";
import { DiagnosticsPanel } from "./diagnostics/DiagnosticsPanel";
import "./styles/App.css";
import ProtectedRoute from "./authentication/ProtectedRoute";
import { PhoneProvider } from "./phone/PhoneProvider";

const diagnosticsEnabled = process.env.REACT_APP_ENABLE_DIAGNOSTICS === "true";

const Pages = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<ProtectedRoute component={Reports} requiredRole="Coach" />}
        />
        <Route
          path="/schedule"
          element={
            <ProtectedRoute component={Schedule} requiredRole={["Coach", "Admin"]} />
          }
        />
        <Route
          path="/schedule/calendar"
          element={
            <ProtectedRoute component={ScheduleCalendarPage} requiredRole={["Coach", "Admin"]} />
          }
        />
        <Route
          path="/diagnostics"
          element={
            diagnosticsEnabled ? (
              <ProtectedRoute component={DiagnosticsPanel} requiredRole="Coach" />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
};

const App = () => {
  return (
    <PageLayout>
      <PhoneProvider>
        <Pages />
      </PhoneProvider>
    </PageLayout>
  );
};

export default App;
